module.exports = __webpack_public_path__ + "static/Li-Ion-Battery-Pack-2-77071917e618e3955acd5d43a8791521.jpg";